export const OFFICES = [
  {
    name: 'Malta Office',
    address: `Level 1,
Tagliaferro Business Centre,
High Street, Sliema,
SLM 1551, Malta`,
    location: {
      lat: 35.910644,
      long: 14.506016,
    },
  },
  {
    name: 'Netherlands Office',
    address: `The Hague Humanity Hub,
Fluwelen Burgwal 58,
2511 CJ Den Haag`,
    location: {
      lat: 52.079245,
      long: 4.318657,
    },
  },
  {
    name: 'Rwanda Office',
    address: `Westerwelle Startup Haus Fl. 4,
Fairview Building,
KG622 Street, Rugando,
Kigali, Rwanda`,
    location: {
      lat: -1.9552914,
      long: 30.0965273,
    },
  },
  {
    name: 'UK Office',
    address: `Trust Stamp, Hub 8,
Unit 2 The Brewery Quarter,
High St, Cheltenham GL50 3FF,
United Kingdom`,
    location: {
      lat: 51.902676,
      long: -2.076349,
    },
  },
  {
    name: 'Atlanta Office',
    address: `3017 Bolling Way NE,
Floors 1 and 2,
Atlanta, Georgia, 30305`,
    location: {
      lat: 33.837684,
      long: -84.380209,
    },
  },
];
